import React from "react";
import { ShoppingCartOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import GradientButton from "../../../common/UI/GradientButton";
import PRODUCT_DETAIL from "./constants";
import useProductDetail from "./hooks/useProductDetail";
import { ProductDetailProps } from "./types";
import PriceBlock from "./components/PriceBlock";
import ProductImage from "./components/ProductImage";
import ProductLoader from "./components/ProductLoader";
import SpecCard from "./components/SpecCard";
import "./index.scss";

const { Text, Title } = Typography;

const ProductDetail: React.FC<ProductDetailProps> = ({
  product,
  loading,
  onGetDevice,
}) => {
  const { features } = useProductDetail(product);

  if (loading) return <ProductLoader />;

  return (
    <div className="pd-root">
      <div className="pd-image-col">
        <ProductImage product={product} />
      </div>

      <div className="pd-content-col">
        <Title level={2} className="pd-title">
          {product.name}
        </Title>

        <Text className="pd-description">{product.description}</Text>

        <PriceBlock product={product} />

        <SpecCard features={features} />

        <GradientButton
          size="large"
          icon={<ShoppingCartOutlined />}
          onClick={onGetDevice}
          className="pd-cta"
        >
          {PRODUCT_DETAIL.LABELS.CTA}
        </GradientButton>
      </div>
    </div>
  );
};

export default ProductDetail;
